<template>
  <div class="topVert">
    <div class="columns is-marginless">
      <div class="circleStyle">
        <b-icon
        icon="circle"
        size="is-small">
        </b-icon>
      </div>
      <h2 class="has-text-weight-bold has-text-link bottomBleu">Cartographie de l’opportunité</h2>
    </div>
    <div class="bottom">
      <app-carte :markers="markers" :markerClient="markerClient" />
    </div>
  </div>
</template>

<script>
import { iconColorGetter, TAILLE_ICON_GRAND, TAILLE_ICON_PETIT } from '@/services/general/iconColorGetter';
import carte from './carte';

export default {
  name: 'index',
  props: ['produits', 'adresseClient'],
  components: {
    appCarte: carte,
  },
  data() {
    return {
      markers: [],
      markerClient: {},
    };
  },
  methods: {
    icon(color, face, colorIcon) {
      if (face.codeFormat === '4' || face.codeFormat === '3' || face.formatCode === '4' || face.formatCode === '3') {
        if (!color) return iconColorGetter(colorIcon, TAILLE_ICON_GRAND, face.azimut, true);
        return iconColorGetter(color, TAILLE_ICON_GRAND, face.azimut, true);
      }
      if (!color) return iconColorGetter(colorIcon, TAILLE_ICON_PETIT, face.azimut, true);
      return iconColorGetter(color, TAILLE_ICON_PETIT, face.azimut, true);
    },
    generateMarkers() {
      this.produits.panneauxLc.forEach(face => {
        this.markers.push({
          ...face,
          type: 'panneauxLc',
        });
      });
      this.produits.reseauxLc.forEach(reseau => {
        reseau.listeFaces.forEach(face => {
          this.markers.push({
            ...face,
            type: 'reseauxLc',
            icon: this.icon(reseau.couleur, face.azimut, '#0062b1'),
          });
        });
      });
      this.produits.panneauxNumeriques.forEach(face => {
        this.markers.push({
          ...face,
          type: 'panneauxNumeriques',
        });
      });
      this.produits.reseauxNumeriques.forEach(reseau => {
        reseau.listeFaces.forEach(face => {
          this.markers.push({
            ...face,
            type: 'reseauxNumeriques',
            icon: this.icon(reseau.couleur, face, '#c242f4'),
          });
        });
      });
      this.produits.reseauxTempo.forEach(reseau => {
        reseau.listeFaces.forEach(face => {
          this.markers.push({
            ...face,
            type: 'reseauxTempo',
            icon: this.icon(reseau.couleur, face, '#49db70'),
          });
        });
      });
      this.produits.reseauxPersonnalise.forEach(reseau => {
        reseau.faces.forEach(face => {
          this.markers.push({
            ...face,
            type: 'reseauxPersonnalise',
            icon: this.icon(reseau.couleur, face, '#c242f4'),
          });
        });
      });
    },
    generateMarkerClient() {
      if (this.adresseClient.lat !== undefined) {
        this.markerClient = {
          ...this.adresseClient,
          icon: iconColorGetter('#000000', TAILLE_ICON_GRAND, null, false),
        };
      }
    },
  },
  mounted() {
    this.generateMarkers();
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/cartoGeneral/index.vue